/**
 * @file paddleJS Hooks
 * @author wanzhongyun
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { fetGetchCommunityInfo } from '../../api/pages/PaddleCommunityApi';
import {
    IPaddleJsBanner,
    IPaddleJsCore,
    IPaddleJsOverview,
    IPaddleJsOnline,
    IPaddleJsImplement,
    IPaddleJsModelService,
    IPaddleJsCase,
    IPaddleJsConsult
} from './type';


const usePaddleJSHooks = () => {
    const [paddleJsBanner, setPaddleJsBanner] = useState<IPaddleJsBanner>({
        title: '',
        desc: '',
        btnWord: '',
        btnLink: ''
    });
    const [paddleJsCore, setPaddleJsCore] = useState<IPaddleJsCore>({title: '', list: []});
    const [paddleJsOverview, setPaddleJsOverview] = useState<IPaddleJsOverview>({
        title: '',
        desc: '',
        image: '',
        btnWord: '',
        bthLink: ''
    });
    const [paddleJsOnline, setPaddleJsOnline] = useState<IPaddleJsOnline>({
        title: '',
        desc: '',
        backgroundImageUrl: '',
        tipsWord: '',
        typeList: []
    });
    const [paddleJsImplement, setPaddleJsImplement] = useState<IPaddleJsImplement>({title: '', imageUrl: '', list: []});
    const [paddleJsModelService, setPaddleJsModelService] = useState<IPaddleJsModelService>({title: '', desc: '', ImageUrl: ''});
    const [paddleJsCase, setPaddleJsCase] = useState<IPaddleJsCase>({title: '', caseList: []});
    const [paddleJsConsult, setPaddleJsConsult] = useState<IPaddleJsConsult>({title: '', caseList: []});

    useMount(() => {
        (async () => {
            const res = await fetGetchCommunityInfo({requestUrl: '/paddlejs'})
                .catch((err) => {
                    // ignore
                });
            if (res) {
                const data = res.body.result?.pageData || {};
                data.paddleJSBanner && setPaddleJsBanner(data.paddleJSBanner);
                data.paddleJSCore && setPaddleJsCore(data.paddleJSCore);
                data.paddleJsOverview && setPaddleJsOverview(data.paddleJsOverview);
                data.paddleJSOnline && setPaddleJsOnline(data.paddleJSOnline);
                data.paddleJSImplement && setPaddleJsImplement(data.paddleJSImplement);
                data.paddleJSModelService && setPaddleJsModelService(data.paddleJSModelService);
                data.paddleJSCase && setPaddleJsCase(data.paddleJSCase);
                data.paddleJSConsult && setPaddleJsConsult(data.paddleJSConsult);
            }
        })();
    });
    
    return {
        paddleJsBanner,
        paddleJsCore,
        paddleJsOverview,
        paddleJsOnline,
        paddleJsImplement,
        paddleJsModelService,
        paddleJsCase,
        paddleJsConsult
    }
}

export default usePaddleJSHooks;